// 此文件不要动
export const nameComponentObj = {
  "wareHouseManage": {
    name: "wareHouseManage",
    label: "仓库管理",
    permissionIdentification: "wareHouse:list", // 权限标识
    recycleBinIdentification: "WareHouse.Index", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "wareHouseModule" */"@/views/ware-house/index.vue")
  }
}

// 没有按钮权限标识数据 也要暴露一个对象出去
export const btnObj = {
  wareHouseCreate: {
    label: "仓库管理/新增仓库",
    value: "wareHouse:create"
  },
  wareHouseDelete: {
    label: "仓库管理/删除仓库",
    value: "wareHouse:delete"
  },
  wareHouseUpdate: {
    label: "仓库管理/更新仓库",
    value: "wareHouse:update"
  },
  wareHouseRead: {
    label: "仓库管理/查看仓库",
    value: "wareHouse:read"
  },
  wareHouseStatus: {
    label: "仓库管理/修改状态",
    value: "wareHouse:status"
  },
  wareHouseManager: {
    label: "仓库管理/设置管理员",
    value: "wareHouse:setManager"
  }
}